import type { ApiClient } from '../../api/client';
import type { InboxPort, InboxRow } from '../../features/inbox/public';
import type { InboxItem } from '../../api/types';
import { workflowTaskProcessLabel } from '../../features/workflow/public';

function displayDate(value?: string): string {
  return value ? value.slice(0, 10).replaceAll('-', '.') : '—';
}

function processStatusLabel(value: string): string {
  const labels: Record<string, string> = { PENDING: '처리 대기', IN_PROGRESS: '처리 대기', COMPLETED: '완료', DENIED: '반려', CANCELLED: '취소' };
  return labels[value] || value;
}

function mapInboxItem(item: InboxItem): InboxRow {
  return {
    id: item.stepId,
    eventId: item.eventId ?? item.id,
    task: { ...item, id: item.stepId, eventId: item.eventId ?? item.id },
    stepId: item.stepId,
    type: workflowTaskProcessLabel(item.processType),
    requester: item.requester.descriptor || '요청자 정보 없음',
    subject: item.subject.descriptor || '대상 정보 없음',
    organization: item.organization?.descriptor || '—',
    requestedAt: displayDate(item.requestedAt),
    effectiveDate: displayDate(item.effectiveDate),
    step: item.step.descriptor || item.step.type,
    status: processStatusLabel(item.step.status || item.status),
  };
}

export function createInboxHttpAdapter(client: ApiClient): InboxPort {
  return {
    async list() {
      return (await client.listInbox()).data.map(mapInboxItem);
    },
    async loadDetail(eventId) {
      const [event, steps] = await Promise.all([
        client.getBusinessProcessEvent(eventId),
        client.listInProgressSteps(eventId),
      ]);
      return { event, steps: steps.data };
    },
    async approve(stepId, comment, key) {
      await client.approveBusinessProcessStep(stepId, comment, key);
    },
    async deny(stepId, comment, key) {
      await client.denyBusinessProcessStep(stepId, comment, key);
    },
  };
}
